/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalAuthSubmissionStatusUpdatedByUserUserType } from './PalAuthSubmissionStatusUpdatedByUserUserType';
import {
    PalAuthSubmissionStatusUpdatedByUserUserTypeFromJSON,
    PalAuthSubmissionStatusUpdatedByUserUserTypeFromJSONTyped,
    PalAuthSubmissionStatusUpdatedByUserUserTypeToJSON,
} from './PalAuthSubmissionStatusUpdatedByUserUserType';

/**
 * 
 * @export
 * @interface PalAuthSubmissionStatusUpdatedByUser
 */
export interface PalAuthSubmissionStatusUpdatedByUser {
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionStatusUpdatedByUser
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionStatusUpdatedByUser
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionStatusUpdatedByUser
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionStatusUpdatedByUser
     */
    title?: string;
    /**
     * 
     * @type {PalAuthSubmissionStatusUpdatedByUserUserType}
     * @memberof PalAuthSubmissionStatusUpdatedByUser
     */
    user_type?: PalAuthSubmissionStatusUpdatedByUserUserType;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionStatusUpdatedByUser
     */
    photo_url?: string;
}

/**
 * Check if a given object implements the PalAuthSubmissionStatusUpdatedByUser interface.
 */
export function instanceOfPalAuthSubmissionStatusUpdatedByUser(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PalAuthSubmissionStatusUpdatedByUserFromJSON(json: any): PalAuthSubmissionStatusUpdatedByUser {
    return PalAuthSubmissionStatusUpdatedByUserFromJSONTyped(json, false);
}

export function PalAuthSubmissionStatusUpdatedByUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionStatusUpdatedByUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'first_name': !exists(json, 'first_name') ? undefined : json['first_name'],
        'last_name': !exists(json, 'last_name') ? undefined : json['last_name'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'user_type': !exists(json, 'user_type') ? undefined : PalAuthSubmissionStatusUpdatedByUserUserTypeFromJSON(json['user_type']),
        'photo_url': !exists(json, 'photo_url') ? undefined : json['photo_url'],
    };
}

export function PalAuthSubmissionStatusUpdatedByUserToJSON(value?: PalAuthSubmissionStatusUpdatedByUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'first_name': value.first_name,
        'last_name': value.last_name,
        'title': value.title,
        'user_type': PalAuthSubmissionStatusUpdatedByUserUserTypeToJSON(value.user_type),
        'photo_url': value.photo_url,
    };
}

